export type TimeReportErrorKey =
  | "Alerts.CannotModifyClosedTimeReport"
  | "Alerts.CannotWithdrawTimeReportClosedApproved"
  | "Alerts.CannotReopenTimeReport"
  | "Alerts.TimeReportNotFound"
  | "Alerts.UnexpectedError";

const MESSAGE_TO_ALERT_KEY: Record<string, TimeReportErrorKey> = {
  "Cannot modify closed time report": "Alerts.CannotModifyClosedTimeReport",
  "Cannot withdraw time report if already closed and approved":
    "Alerts.CannotWithdrawTimeReportClosedApproved",
  "Cannot reopen this time report": "Alerts.CannotReopenTimeReport",
  "Time report not found": "Alerts.TimeReportNotFound",
};

export const resolveAlertKey = (message: string): TimeReportErrorKey =>
  MESSAGE_TO_ALERT_KEY[message] ?? "Alerts.UnexpectedError";
